/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Fw_Tpl_VerifiedInputs */

const en_fw_tpl_verified = /** @type {(inputs: Fw_Tpl_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} verified`)
};

const id_fw_tpl_verified = /** @type {(inputs: Fw_Tpl_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} terverifikasi`)
};

/**
* | output |
* | --- |
* | "{n} verified" |
*
* @param {Fw_Tpl_VerifiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_verified = /** @type {((inputs: Fw_Tpl_VerifiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_VerifiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_verified(inputs)
	return en_fw_tpl_verified(inputs)
});